<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import DefaultWhiteCard from "@/components/global-themed/ui/sections/DefaultWhiteCard.vue";
import HeadingTitle from "@/components/website/v2/ui/HeadingTitle.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import SectionText from "@/components/website/v2/ui/SectionText.vue";
import SectionBorderedWrapper from "@/components/website/v2/ui/SectionBorderedWrapper.vue";
import SectionSubText from "@/components/website/v2/ui/SectionSubText.vue";
import KitShadow from "@/components/website/v2/ui/KitShadow.vue";
import {changeStep, isSavingCurrentStep, Steps} from "@/composables/ai-onboarding/useSteps";
import {getIndustryWord} from "@/composables/industry-content/useIndustryContent";
const emit = defineEmits(['changeStep']);

defineProps({
  canBypassAiOnboarding: {
    type: Boolean,
    required: true,
  },
});

const handleContinue = () => {
  changeStep(Steps.value.LOCATIONS, emit);
}
</script>

<template>
  <DefaultWhiteCard>
    <div class="tw-flex tw-flex-col tw-gap-y-16 tw-items-center">
      <HeadingTitle>Right, time to build your website's SEO strategy 🛠️</HeadingTitle>
      <div class="tw-flex tw-flex-col tw-gap-y-8 tw-items-center">
        <div class="tw-flex tw-flex-col tw-items-center tw-gap-4">
          <KitIcon
            class="tw-w-36"
          />
          <KitShadow class="tw-w-[120px]" />
        </div>
        <SectionBorderedWrapper>
          <SectionText>
            I'm now going to ask you a few questions about your {{ getIndustryWord('business') }}, {{ getIndustryWord('customers') }}, and goals so I can create a focused
            SEO plan that brings you the right traffic.
          </SectionText>

          <SectionSubText>
            This should take around 10–15 minutes, and I'll guide you every step of the way. Ready to begin?
          </SectionSubText>

          <DefaultButton
            class="tw-w-60 tw-m-auto"
            :loading="isSavingCurrentStep"
            @click="handleContinue"
          >
            Let's go!
          </DefaultButton>

          <a
            v-if="canBypassAiOnboarding"
            class="tw-text-base tw-font-bold tw-text-primary tw-underline tw-text-center"
            href="/onboarding"
          >
            I’ll build my strategy myself
          </a>
        </SectionBorderedWrapper>
      </div>
    </div>
  </DefaultWhiteCard>
</template>
